import { Component, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-submit-button',
  templateUrl: './submit-button.component.html',
  styleUrls: ['./submit-button.component.scss']
})
export class SubmitButtonComponent implements OnInit {
  @Input() ready: boolean;
  @Input() loading: boolean;

  constructor() {}

  ngOnInit(): void {}
}
